import HmacSHA256 from 'crypto-js/hmac-sha256'
import Hex from 'crypto-js/enc-hex'
import * as Sentry from '@sentry/react'
import { LOADING_USER, SET_ACCOUNT, SWITCH_COMPANY } from '../reducers/auth'
import { getAccount } from '../api/user'

export const get_account = (loading = true) => {
  return (dispatch) => {
    if (loading) {
      dispatch({ type: LOADING_USER })
    }

    const currentCompany = localStorage.getItem('current_company')
    getAccount(currentCompany ? JSON.parse(currentCompany).id : null)
      .then((user) => {
        dispatch({ type: SET_ACCOUNT, data: user })

        Sentry.setUser({
          id: user.id,
          username: user.username,
          email: user.email,
        })

        if (user.company) {
          dispatch({
            type: SWITCH_COMPANY,
            data: user.company,
            currentRole: user.role,
          })
          localStorage.setItem('current_company', JSON.stringify(user.company))

          // try {
          //   window.Tawk_API.login(
          //     {
          //       hash: Hex.stringify(
          //         HmacSHA256(
          //           user.id.toString(),
          //           '62ccf9f789361eb4c8c4fc06b60eac81422a5d7c'
          //         )
          //       ), // required
          //       userId: user.id.toString(), // required
          //       name: `${user.firstname} ${user.lastname}`,
          //       email: user.email,
          //       phone: user.phoneNumber,
          //     },
          //     (error) => {
          //       console.error(error)
          //     }
          //   )
          // } catch (tawkError) {
          //   console.error('Tawk_API.login error:', tawkError)
          // }
        }

        dispatch({ type: LOADING_USER, loading: false })
      })
      .catch(() => {})
  }
}

export const light_get_account = () => {
  return (dispatch) => {
    getAccount()
      .then((user) => {
        dispatch({ type: SET_ACCOUNT, data: user })

        if (user.company) {
          dispatch({
            type: SWITCH_COMPANY,
            data: user.company,
            currentRole: user.role,
          })
          localStorage.setItem('current_company', JSON.stringify(user.company))
        }
      })
      .catch(() => {})
  }
}

export const update_user_local = (values) => {
  return (dispatch) => {
    dispatch({ type: SET_ACCOUNT, data: values })
  }
}
